/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
//
// try {
//     window.$ = window.jQuery = require("jquery");
//
//     require("bootstrap");
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}

//Костыль, чтобы не отваливался роутинг после того, как сдохнет токен авторизации
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if(error.response && error.response.config) {
        if (401 === error.response.status && error.response.config.url ===
            'auth/refresh') {
            console.log("Токен авторизации невалиден")
            return Promise.resolve(error.response);
        }
    }
    return Promise.reject(error);
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
    broadcaster: "pusher",
    authEndpoint: "/api/broadcasting/auth",
    key: "regiontorg42",
    wsHost: window.location.hostname,
    wsPort: 80,
    disableStats: true,
    enabledTransports: ["ws"],
    httpHost: null,
    statsHost: null,
    unavailable_timeout: 1000,
    auth: {
        headers: {
            Authorization: "Bearer " + localStorage["Authorization"],
            Accept: "application/json",
        },
    },
});
